<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">CONTENTS</p>
<p class="cont"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="cont"><a href="#/introduction">Introduction</a></p>
<p class="cont1"><a href="#/chapter01">GREED IS THE COLOR OF GOLD: GOLD MINING IN CHARLOTTE’S EARLY HISTORY</a></p>
<p class="cont"><a href="#/chapter01#sec1.1">The First Gold Rush In America</a></p>
<p class="cont"><a href="#/chapter01#sec1.2">Crimes Associated With the Mines</a></p>
<p class="cont"><a href="#/chapter01#sec1.3">The Charlotte Mint</a></p>
<p class="cont1"><span href="#/chapter02" title="Link target outside of Sample">ROBBERIES: HITTING CHARLOTTE IN THE POCKETBOOK</span></p>
<p class="cont"><span href="#/chapter02#sec2.1" title="Link target outside of Sample">Commando Gang Robs Belk’s</span></p>
<p class="cont"><span href="#/chapter02#sec2.2" title="Link target outside of Sample">The Loomis Fargo Theft</span></p>
<p class="cont"><span href="#/chapter02#sec2.3" title="Link target outside of Sample">Gangster Heist Defines Charlotte’s “Crime of the Century”</span></p>
<p class="cont1"><span href="#/chapter03" title="Link target outside of Sample">THE TASTE OF WHITE LIGHTNING: BOOTLEGGERS, SPEAKEASIES AND THE RISE OF NASCAR</span></p>
<p class="cont"><span href="#/chapter03#sec3.1" title="Link target outside of Sample">Bootlegging in the Piedmont</span></p>
<p class="cont"><span href="#/chapter03#sec3.2" title="Link target outside of Sample">Speakeasies in the Queen City</span></p>
<p class="cont"><span href="#/chapter03#sec3.3" title="Link target outside of Sample">The Rise of NASCAR</span></p>
<p class="cont1"><span href="#/chapter04" title="Link target outside of Sample">SCOUNDRELS, CADS AND MISBEHAVING WOMEN</span></p>
<p class="cont"><span href="#/chapter04#sec4.1" title="Link target outside of Sample">Teenage Girl With Arson on Her Mind</span></p>
<p class="cont"><span href="#/chapter04#sec4.2" title="Link target outside of Sample">Jim Bakker: Greed and God in a Theme Park</span></p>
<p class="cont"><span href="#/chapter04#sec4.3" title="Link target outside of Sample">Jeanette Lark: A Public Prostitute</span></p>
<p class="cont"><span href="#/chapter04#sec4.4" title="Link target outside of Sample">Ku Klux Klan: Rearing Its Ugly Head Early</span></p>
<p class="cont"><span href="#/chapter04#sec4.5" title="Link target outside of Sample">KKK’s September of 1957</span></p>
<p class="cont"><span href="#/chapter04#sec4.6" title="Link target outside of Sample">The Targeting of Julius Chambers</span></p>
<p class="cont1"><span href="#/chapter05" title="Link target outside of Sample">NOTORIOUS MURDERERS AND THEIR EVIL DEEDS</span></p>
<p class="cont"><span href="#/chapter05#sec5.1" title="Link target outside of Sample">The Murder of Francis Bradley: The Strongest Patriot</span></p>
<p class="cont"><span href="#/chapter05#sec5.2" title="Link target outside of Sample">W.J. Cash: Suicide or Murder?</span></p>
<p class="cont"><span href="#/chapter05#sec5.3" title="Link target outside of Sample">Henry Louis Wallace: The Charlotte Strangler</span></p>
<p class="cont"><span href="#/chapter05#sec5.4" title="Link target outside of Sample">Rae Carruth: Pro Athlete and Murderer For Hire</span></p>
<p class="cont1"><span href="#/appendix" title="Link target outside of Sample">Appendix: “Sin With a Southern Accent” by Stephen Hull</span></p>
<p class="cont"><span href="#/references" title="Link target outside of Sample">References</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a8f94822